import React from 'react';
import { Link } from 'react-router-dom';
import { Shell } from '../components/Shell';
import { BRAND, SUPPORT_EMAIL } from '../lib/api';

export default function ContactPage() {
  return (
    <Shell narrow>
      <h1 className="text-xl font-bold mb-6">Help</h1>
      <div className="card space-y-4 text-sm">
        <div>
          <p className="text-muted">Email</p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand">{SUPPORT_EMAIL}</a>
        </div>
      </div>
      <Link to="/" className="btn-ghost mt-6 inline-flex">← Back</Link>
    </Shell>
  );
}

export function LegalPage({ title, children }) {
  return (
    <Shell narrow>
      <h1 className="text-xl font-bold mb-4">{title}</h1>
      <div className="card text-sm text-muted leading-relaxed space-y-3">{children}</div>
      <Link to="/" className="btn-ghost mt-6 inline-flex">← Back</Link>
    </Shell>
  );
}

export function PrivacyPage() {
  return (
    <LegalPage title="Privacy">
      <p>{BRAND} collects email and phone when you purchase a report, plus search parameters. Data is used to deliver reports and improve the service.</p>
      <p>Property data comes from public government records. Contact {SUPPORT_EMAIL} with questions.</p>
    </LegalPage>
  );
}

export function TermsPage() {
  return (
    <LegalPage title="Terms">
      <p>{BRAND} provides registry information for reference only — not legal proof of ownership.</p>
      <p>Verify all details with official IGR offices. Use the service lawfully. Governed by Indian law.</p>
    </LegalPage>
  );
}

export function MaintenancePage({ message }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-wash">
      <div className="card max-w-sm text-center">
        <p className="font-semibold">{BRAND}</p>
        <p className="text-sm text-muted mt-3">{message || 'Under maintenance. Back soon.'}</p>
      </div>
    </div>
  );
}
